// extracted by mini-css-extract-plugin
export default {"image":"Primermainproduct_image__PwBya"};